import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitLawyer } from './hooks'
import { TableLawyer } from './TableLawyer'
import { FormLawyer } from './FormLawyer'
import { ModalModule } from './ModalModule'

export const Lawyer = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitLawyer({location, paramsURL})

    const {
        globalStates,
        Actions
    } = useFetchInit
    
    const { showForm } = globalStates
    const { handleClickShowForm } = Actions

    return (
        <AllowedAccess permissions={['221_PROCESOS']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit} />
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                
                                <div className='h4 mt-1 mb-1'> Abogacía & Notariado: Activos</div>
                                <div className="border-bottom border-dark"></div>
                                <div className="d-flex justify-content-end pt-4">
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type="button"
                                        onClick={() => handleClickShowForm(true)}
                                    >
                                        <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                    </Button>
                                </div>
                                <div className="pt-4"></div>
                                <TableLawyer useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <FormLawyer useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}
